<div class="absolute inset-0 flex min-w-0 flex-col overflow-auto">
    <!-- Main -->
    <div class="flex-1 flex flex-col">
        <!-- Header -->
        <div class="bg-default flex flex-col items-start px-6 py-8 sm:flex-row sm:items-center sm:justify-between md:px-8 flex-shrink-0">
            <!-- Title -->
            <div>
            <div class="text-4xl font-extrabold leading-none tracking-tight">{{ currentViewTitle }}</div>
            <div class="text-secondary ml-0.5 font-medium">
                <span>{{ currentViewDescription }}</span>
            </div>
        </div>
            
            <!-- Search and Actions -->
            <div class="mt-4 sm:mt-0 flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                <!-- Search Bar -->
                <div class="relative w-full sm:w-64">
                    <div class="relative">
                        <mat-icon class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">search</mat-icon>
                        <input type="text" 
                               [(ngModel)]="searchQuery"
                               (ngModelChange)="onSearchInput()"
                               (focus)="showSearchDropdown = filteredUsers.length > 0 && searchQuery.trim() !== ''"
                               (blur)="onSearchBlur()"
                               placeholder="Search by name, email, role or company..."
                               class="w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white">
                        
                        <!-- Clear button -->
                        <button *ngIf="searchQuery" 
                                (click)="clearSearch()"
                                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                            <mat-icon class="text-sm">close</mat-icon>
                        </button>
                    </div>
                    
                    <!-- Search Dropdown -->
                    <div *ngIf="showSearchDropdown && filteredUsers.length > 0" 
                         class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-80 overflow-y-auto">
                        <div class="p-2">
                            <div class="text-xs font-semibold text-gray-500 px-3 py-2">Search Results ({{filteredUsers.length}})</div>
                            <div class="divide-y divide-gray-100">
                                <div *ngFor="let user of filteredUsers" 
                                     (click)="selectUser(user)"
                                     class="px-3 py-3 hover:bg-blue-50 cursor-pointer transition-colors duration-150">
                                    <div class="flex items-center">
                                        <div class="w-8 h-8 rounded-full flex items-center justify-center mr-3 overflow-hidden" 
                                             [style.background-color]="user.avatarColor">
                                            <span class="text-white text-xs font-bold">
                                                {{user.firstNameLetter}}
                                            </span>
                                        </div>
                                        <div class="flex-1 min-w-0">
                                            <div class="font-medium text-gray-900 truncate">{{user.name}}</div>
                                            <div class="text-sm text-gray-500 truncate">{{user.email}}</div>
                                            <div class="text-xs text-gray-400 mt-1">
                                                <span [ngClass]="user.roleBadgeClass" class="inline-flex items-center px-2 py-0.5 rounded">
                                                    {{user.roleDisplay}}
                                                </span>
                                                <span class="mx-1">•</span>
                                                <span [ngClass]="user.isEmailVerified ? 'text-green-600' : 'text-yellow-600'">
                                                    {{user.isEmailVerified ? 'Verified' : 'Unverified'}}
                                                </span>
                                            </div>
                                        </div>
                                        <mat-icon class="text-gray-400 ml-2">chevron_right</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Selected User Badge -->
                    <div *ngIf="selectedUser" class="mt-2">
                        <div class="inline-flex items-center bg-blue-50 text-blue-700 px-3 py-1.5 rounded-full text-sm">
                            <div class="w-4 h-4 rounded-full mr-1 flex items-center justify-center overflow-hidden" 
                                 [style.background-color]="selectedUser.avatarColor">
                                <span class="text-white text-xs font-bold">
                                    {{selectedUser.firstNameLetter}}
                                </span>
                            </div>
                            <span class="font-medium">{{selectedUser.name}}</span>
                            <span class="mx-2">•</span>
                            <span [ngClass]="selectedUser.roleBadgeClass" class="text-xs px-2 py-0.5 rounded">
                                {{selectedUser.roleDisplay}}
                            </span>
                            <button (click)="clearSearch()" class="ml-2 text-blue-500 hover:text-blue-700">
                                <mat-icon class="text-sm">close</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                
                <!-- Refresh Button -->
                <button mat-button 
                        (click)="refreshUsers()"
                        class="inline-flex items-center justify-center px-4 py-2.5 border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-700">
                    <mat-icon class="mr-2">refresh</mat-icon>
                    Refresh
                </button>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="flex-1 flex items-center justify-center">
            <div class="text-center">
                <mat-spinner diameter="50"></mat-spinner>
                <p class="mt-4 text-gray-600">Loading users...</p>
            </div>
        </div>

        <!-- Users Table -->
        <div *ngIf="!isLoading" class="px-6 md:px-8 pb-8 flex-1 overflow-auto">
            <!-- Search Info -->
            <div *ngIf="isSearchActive" class="mb-4">
                <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <mat-icon class="text-blue-600 mr-2">info</mat-icon>
                            <span class="text-blue-700">
                                Showing search results for "{{searchQuery}}"
                            </span>
                        </div>
                        <button mat-button 
                                (click)="clearSearch()"
                                class="text-blue-600 hover:text-blue-800">
                            Clear Search
                        </button>
                    </div>
                </div>
            </div>
            
            <!-- Users Table -->
            <div *ngIf="usersDataSource.data.length > 0" class="mb-8 w-full">
                <div class="bg-white rounded-lg shadow overflow-hidden w-full">
                    <!-- Table Container -->
                    <div class="overflow-x-auto w-full">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        User
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Contact Info
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Role & Status
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Profile Info
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Created Date
                                    </th>
                                    <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <ng-container *ngFor="let user of usersDataSource.data; trackBy: trackByFn; let i = index">
                                    <!-- Main Row -->
                                    <tr id="user-{{user._id}}" class="hover:bg-gray-50">
                                        <!-- User Column -->
                                        <td class="px-6 py-4 whitespace-nowrap">
                                            <div class="flex items-center">
                                                <div class="flex-shrink-0 h-10 w-10 rounded-full overflow-hidden" 
                                                     [style.background-color]="user.avatarColor">
                                                    <span class="h-full w-full flex items-center justify-center text-white text-sm font-bold">
                                                        {{user.firstNameLetter}}
                                                    </span>
                                                </div>
                                                <div class="ml-4">
                                                    <div class="text-sm font-medium text-gray-900">{{user.name}}</div>
                                                    <div class="text-xs text-gray-500">
                                                        {{ user.profileType | titlecase }}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Contact Info Column -->
                                        <td class="px-6 py-4">
                                            <div class="text-sm text-gray-900">{{user.email}}</div>
                                            <div class="text-xs text-gray-500">
                                                Country: {{user.country || 'N/A'}}
                                            </div>
                                        </td>

                                        <!-- Role & Status Column -->
                                        <td class="px-6 py-4">
                                            <div class="space-y-1">
                                                <span class="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium"
                                                      [ngClass]="user.roleBadgeClass">
                                                    {{user.roleDisplay}}
                                                </span>
                                                <div class="text-xs text-gray-600">
                                                    Email: {{ user.isEmailVerified ? '✓ Verified' : '✗ Unverified' }}
                                                </div>
                                                <div class="text-xs text-gray-600">
                                                    Phone: {{ user.isPhoneVerified ? '✓ Verified' : '✗ Unverified' }}
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Profile Info Column -->
                                        <td class="px-6 py-4">
                                            <div class="text-sm text-gray-900">
                                                Language: {{ user.language === 'en' ? 'English' : 
                                                           user.language === 'ar' ? 'Arabic' : 
                                                           user.language }}
                                            </div>
                                            <div class="text-xs text-gray-500">
                                                Company: {{user.companyName || 'N/A'}}
                                            </div>
                                        </td>

                                        <!-- Created Date Column -->
                                        <td class="px-6 py-4 whitespace-nowrap">
                                            <div class="text-sm text-gray-900">{{formatDateShort(user.createdAt)}}</div>
                                            <div class="text-xs text-gray-500">
                                                {{ getTimeFromDate(user.createdAt) }}
                                            </div>
                                        </td>

                                        <!-- Actions Column -->
                                        <td class="px-6 py-4 whitespace-nowrap text-right">
                                            <div class="flex justify-end items-center space-x-1">
                                                <!-- Edit button -->
                                                <button mat-icon-button 
                                                        matTooltip="Edit User"
                                                        class="text-blue-600 hover:bg-blue-50"
                                                        (click)="editUser(user, $event)">
                                                    <mat-icon>edit</mat-icon>
                                                </button>
                                                
                                                <!-- Delete button -->
                                                <button *ngIf="canPerformDestructiveActions" mat-icon-button
                                                        matTooltip="Delete User"
                                                        class="text-red-600 hover:bg-red-50"
                                                        (click)="deleteUser(user, $event)">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                                
                                                <!-- Expand button -->
                                                <button mat-icon-button 
                                                        matTooltip="View Details"
                                                        class="text-blue-600 hover:bg-blue-50"
                                                        (click)="toggleRow(user._id, $event)">
                                                    <mat-icon *ngIf="!isUserExpanded(user._id)">expand_more</mat-icon>
                                                    <mat-icon *ngIf="isUserExpanded(user._id)">expand_less</mat-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Expanded Details Row -->
                                    <tr *ngIf="isUserExpanded(user._id)" class="bg-blue-50">
                                        <td colspan="6" class="px-6 py-4">
                                            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                <!-- User Details -->
                                                <div class="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                                    <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                                        <mat-icon class="mr-2 text-blue-600">person</mat-icon>
                                                        User Details
                                                    </h3>
                                                    <div class="space-y-3">
                                                        <!-- Removed User ID display -->
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">title</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Name:</span>
                                                            <span class="text-sm font-semibold">{{user.name}}</span>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">email</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Email:</span>
                                                            <a [href]="'mailto:' + user.email" 
                                                               class="text-blue-600 hover:text-blue-800 hover:underline text-sm">
                                                                {{user.email}}
                                                            </a>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">verified</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Email Verified:</span>
                                                            <span [ngClass]="user.isEmailVerified ? 'text-green-600' : 'text-red-600'" 
                                                                  class="text-sm font-medium">
                                                                {{user.isEmailVerified ? 'Yes ✓' : 'No ✗'}}
                                                            </span>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">phone</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Phone Verified:</span>
                                                            <span [ngClass]="user.isPhoneVerified ? 'text-green-600' : 'text-red-600'" 
                                                                  class="text-sm font-medium">
                                                                {{user.isPhoneVerified ? 'Yes ✓' : 'No ✗'}}
                                                            </span>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">language</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Language:</span>
                                                            <span class="text-sm">{{user.language === 'en' ? 'English' : 
                                                                   user.language === 'ar' ? 'Arabic' : 
                                                                   user.language}}</span>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">flag</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Country:</span>
                                                            <span class="text-sm">{{user.country || 'N/A'}}</span>
                                                        </div>
                                                        <div *ngIf="user.lastPasswordUpdate" class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400">lock_clock</mat-icon>
                                                            <span class="text-sm font-medium text-gray-600 mr-2">Password Updated:</span>
                                                            <span class="text-sm">{{formatDateShort(user.lastPasswordUpdate)}}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Additional Information -->
                                                <div class="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                                                    <h3 class="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                                                        <mat-icon class="mr-2 text-green-600">info</mat-icon>
                                                        Additional Information
                                                    </h3>
                                                    <div class="space-y-3">
                                                        <!-- Role Details -->
                                                        <div>
                                                            <div class="flex items-center mb-1">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 16px;">admin_panel_settings</mat-icon>
                                                                <span class="text-sm font-medium text-gray-600">Role:</span>
                                                            </div>
                                                            <div class="flex items-center">
                                                                <span class="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium mr-2"
                                                                      [ngClass]="user.roleBadgeClass">
                                                                    {{user.roleDisplay}}
                                                                </span>
                                                                <span class="text-sm text-gray-600">
                                                                    {{user.role}}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <!-- Profile Type -->
                                                        <div>
                                                            <div class="flex items-center mb-1">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 16px;">visibility</mat-icon>
                                                                <span class="text-sm font-medium text-gray-600">Profile Type:</span>
                                                            </div>
                                                            <span class="inline-flex items-center rounded-full px-3 py-1 text-xs font-medium"
                                                                  [ngClass]="{
                                                                    'bg-green-100 text-green-800': user.profileType === 'public',
                                                                    'bg-blue-100 text-blue-800': user.profileType === 'private'
                                                                  }">
                                                                {{ user.profileType | titlecase }}
                                                            </span>
                                                        </div>

                                                        <!-- Company Info -->
                                                        <div>
                                                            <div class="flex items-center mb-1">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 16px;">business</mat-icon>
                                                                <span class="text-sm font-medium text-gray-600">Company:</span>
                                                            </div>
                                                            <p class="text-sm text-gray-900">{{user.companyName || 'N/A'}}</p>
                                                        </div>

                                                        <!-- Dates -->
                                                        <div class="pt-3 border-t border-gray-100">
                                                            <div class="grid grid-cols-2 gap-2 text-xs text-gray-500">
                                                                <div>
                                                                    <div class="font-medium">Created:</div>
                                                                    <div>{{formatDateShort(user.createdAt)}}</div>
                                                                </div>
                                                                <div>
                                                                    <div class="font-medium">Updated:</div>
                                                                    <div>{{formatDateShort(user.updatedAt)}}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>

                    <!-- Table Footer with Pagination -->
                    <div class="bg-gray-50 px-6 py-3 border-t border-gray-200">
                        <div class="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                            <div class="text-sm text-gray-700">
                                Showing <span class="font-medium">{{usersDataSource.data.length}}</span> of 
                                <span class="font-medium">{{totalUsers}}</span> users
                                <span *ngIf="isSearchActive" class="text-blue-600 ml-2">
                                    (Search Results)
                                </span>
                            </div>
                            
                            <mat-paginator [length]="totalUsers"
                                           [pageSize]="pageSize"
                                           [pageSizeOptions]="pageSizeOptions"
                                           [pageIndex]="currentPage"
                                           (page)="onPageChange($event)"
                                           aria-label="Select page"
                                           class="border-0">
                            </mat-paginator>
                            
                            <button mat-button 
                                    (click)="refreshUsers()"
                                    class="text-blue-600 hover:text-blue-800">
                                <mat-icon>refresh</mat-icon>
                                <span class="ml-1">Refresh</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="usersDataSource.data.length === 0 && !isLoading" class="text-center py-12">
                <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 mb-4">
                    <mat-icon class="text-gray-400" style="width: 32px; height: 32px; font-size: 32px;">people</mat-icon>
                </div>
                <h3 class="text-lg font-medium text-gray-900 mb-2">
                    {{ isSearchActive ? 'No matching users found' : 'No users found' }}
                </h3>
                <p class="text-gray-500 mb-4">
                    {{ isSearchActive ? 'Try a different search term' : 'There are no users registered in the system.' }}
                </p>
                <button *ngIf="isSearchActive" 
                        mat-button 
                        (click)="clearSearch()"
                        class="text-blue-600 hover:text-blue-800">
                    Clear Search
                </button>
            </div>
        </div>
    </div>
</div>
